var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaceLow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 89 89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#ff3000;}.cls-3{fill:#053b5c;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "face_low") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 44.5,
    cy: 44.5,
    r: 39.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.2,67.21a2.5,2.5,0,0,1-4.41,1.37,22.48,22.48,0,0,0-34.58,0,2.51,2.51,0,0,1-3.52.31,2.52,2.52,0,0,1-.32-3.52,27.51,27.51,0,0,1,42.26,0A2.46,2.46,0,0,1,66.2,67.21Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 29.5,
    cy: 35.5,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 59.5,
    cy: 35.5,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.5,0A44.5,44.5,0,1,0,89,44.5,44.55,44.55,0,0,0,44.5,0Zm0,84A39.5,39.5,0,1,1,84,44.5,39.55,39.55,0,0,1,44.5,84Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceLow);
export default __webpack_public_path__ + "static/media/face_low.2d581ad637fd5c3854e4aa40a285ca0f.svg";
export { ForwardRef as ReactComponent };